import React, { useMemo, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { FaChalkboardTeacher, FaUserAlt } from "react-icons/fa";
import { IoIosPaper } from "react-icons/io";
import { ImBooks } from "react-icons/im";
import { RiTeamFill } from "react-icons/ri";
import logo from "../../../../shared/resources/in-white-logo-only.png";
import "./styles.scss";
import { useHistory, useLocation } from "react-router-dom";
import { DashboardPages } from "../../containers";
import { useAppUser } from "../../../../contexts/user-context/UserContext";

import { MdArchive, MdForum, MdPieChart, MdPublic } from "react-icons/md";
import { DashboardMentoringPages } from "../../../mentoring/containers/Mentoring";
import { HiSpeakerphone } from "react-icons/hi";
import { useAnnouncements } from "../../../../contexts/announcement-context/AnnouncementContext";
import random from "randomstring";
import { BarLoader } from "react-spinners";
import { useFunctions } from "reactfire";
import ForumUtils from "../../../../shared/utils/ForumUtils";
import { useAppContext } from "../../../../contexts/app-context/AppContext";
import ConfirmationModal from "../../../../shared/components/confirmationModal/ConfirmationModal";
import {
  CurrentAction,
  UserPrivilege,
} from "../../../../shared/constants/Constant";
import { DashboardLibraryPages } from "../../containers/library/containers/LibraryRoutes";
import { usePermission } from "../../../../shared/hooks/usePermission";

const SideNavBar = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const appUser = useAppUser();
  const { announcements } = useAnnouncements();
  const [fLoading, setFLoading] = useState(false);
  const app = useAppContext();
  const [showModel, setShowModel] = useState(false);
  const isNavigationAllowed = app.getCurrentAction().allowNavigationAway;

  const getUnreadCount = useMemo(() => {
    return (): number => {
      return announcements.filter((a) => !a.read).length;
    };
  }, [announcements]);

  const saveForumPasswordFunction = useFunctions().httpsCallable(
    "saveForumPassword"
  );

  const gotoForum = () => {
    setFLoading(true);

    if (appUser.forumPassword) {
      const forumData = ForumUtils.getForumDataIfAailable();

      if (forumData) {
        setFLoading(false);
        ForumUtils.goToForum(forumData);
      } else {
        ForumUtils.login(
          {
            email: appUser.fireUser?.email || "",
            password: appUser.forumPassword,
          },
          (data) => {
            setFLoading(false);
          },
          (err) => {
            console.log("error on forum:", err);
            setFLoading(false);
          },
          true
        );
      }
    } else {
      //register
      ForumUtils.register(
        {
          displayName: appUser.displayName,
          email: appUser.fireUser?.email || "",
          password: random.generate(),
          profileImage: appUser.photoURL,
          role: appUser.userRole.isAdmin
            ? "ADMIN"
            : appUser.userRole.isModerator
            ? "MODERATOR"
            : "USER",
        },
        saveForumPasswordFunction,
        (data) => {
          setFLoading(false);
        },
        (err) => {
          setFLoading(false);
        },
        true
      );
    }
  };

  return (
    <>
      <Container fluid className="side-nav-bar-wrapper d-none d-md-block">
        <Row className="navi-item-logo">
          <Col xs={12}>
            <div className="navi-logo">
              <img src={logo} alt="" />
            </div>
          </Col>
        </Row>
        <Row
          className={
            pathname.includes(DashboardPages.ACCOUNT)
              ? "navi-item active"
              : "navi-item "
          }
        >
          <Col
            xs={12}
            onClick={() => {
              if (!isNavigationAllowed) {
                app.pushBackURL(DashboardPages.ACCOUNT);
                setShowModel(true);
              } else {
                history.push(DashboardPages.ACCOUNT);
              }
            }}
          >
            <div className="navi-icon">
              <FaUserAlt />
            </div>
            <div className="navi-text">Account</div>
          </Col>
        </Row>
        {appUser.userRole.isModerator && (
          <Row
            className={
              pathname === DashboardPages.DASHBOARD
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardPages.DASHBOARD);
                  setShowModel(true);
                } else {
                  history.push(DashboardPages.DASHBOARD);
                }
              }}
            >
              <div className="navi-icon">
                <MdPieChart />
              </div>
              <div className="navi-text">Dashboard</div>
            </Col>
          </Row>
        )}
        {(appUser.userRole.isAdmin || appUser.userRole.isModerator) && (
          <Row
            className={
              pathname === DashboardPages.HOME
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardPages.HOME);
                  setShowModel(true);
                } else {
                  history.push(DashboardPages.HOME);
                }
              }}
            >
              <div className="navi-icon">
                <IoIosPaper />
              </div>
              <div className="navi-text">Applications</div>
            </Col>
          </Row>
        )}
        {appUser.userRole.isModerator && (
          <Row
            className={
              pathname.includes(DashboardPages.TEAMS)
                ? "navi-item active"
                : "navi-item"
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardPages.TEAMS);
                  setShowModel(true);
                } else {
                  history.push(DashboardPages.TEAMS);
                }
              }}
            >
              <div className="navi-icon">
                <RiTeamFill />
              </div>
              <div className="navi-text">Teams</div>
            </Col>
          </Row>
        )}
        {usePermission(UserPrivilege.LIBRARY) && (
          <Row
            className={
              pathname.includes(DashboardPages.LIBRARY) ||
              pathname.includes(DashboardPages.WORKSHOP.replace(":id", ""))
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardLibraryPages.WORKSHOPS);
                  setShowModel(true);
                } else {
                  history.push(DashboardLibraryPages.WORKSHOPS);
                }
              }}
            >
              <div className="navi-icon">
                <ImBooks />
              </div>
              <div className="navi-text">Library</div>
            </Col>
          </Row>
        )}
        {usePermission(UserPrivilege.MENTORS) && (
          <Row
            className={
              pathname.includes(DashboardPages.MENTORING)
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(
                    appUser.userRole.isModerator
                      ? DashboardMentoringPages.MENTORING_SESSION_REQUESTS
                      : DashboardMentoringPages.MENTOR_PROFILES
                  );
                  setShowModel(true);
                } else {
                  history.push(
                    appUser.userRole.isModerator
                      ? DashboardMentoringPages.MENTORING_SESSION_REQUESTS
                      : DashboardMentoringPages.MENTOR_PROFILES
                  );
                }
              }}
            >
              <div className="navi-icon">
                <FaChalkboardTeacher />
              </div>
              <div className="navi-text">Mentors</div>
            </Col>
          </Row>
        )}
        {appUser.userRole.isAdmin && (
          <Row
            className={
              pathname.includes(DashboardPages.PUBLIC)
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardPages.PUBLIC);
                  setShowModel(true);
                } else {
                  history.push(DashboardPages.PUBLIC);
                }
              }}
            >
              <div className="navi-icon">
                <MdPublic />
              </div>
              <div className="navi-text">Public</div>
            </Col>
          </Row>
        )}
        {usePermission(UserPrivilege.NOTICES) && (
          <Row
            className={
              pathname.includes(DashboardPages.ANNOUNCEMENTS)
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(
                    appUser.userRole.isModerator
                      ? DashboardPages.ANNOUNCEMENTS_CREATE
                      : DashboardPages.ANNOUNCEMENTS
                  );
                  setShowModel(true);
                } else {
                  history.push(
                    appUser.userRole.isModerator
                      ? DashboardPages.ANNOUNCEMENTS_CREATE
                      : DashboardPages.ANNOUNCEMENTS
                  );
                }
              }}
            >
              {!appUser.userRole.isModerator && getUnreadCount() !== 0 && (
                <div className="notifi-icon">{getUnreadCount()}</div>
              )}
              <div className="navi-icon">
                <HiSpeakerphone />
              </div>
              <div className="navi-text">Notices</div>
            </Col>
          </Row>
        )}
        {usePermission(UserPrivilege.FORUM) && (
          <Row className="navi-item ">
            <Col
              xs={12}
              onClick={() => {
                gotoForum();
              }}
            >
              <div className="navi-icon">
                <MdForum />
              </div>
              <div className="navi-text">Forum</div>
            </Col>
          </Row>
        )}
        {usePermission(UserPrivilege.LIBRARY) && (
          <Row
            className={
              pathname.includes(DashboardPages.ARCHIVED_WORKSHOPS)
                ? "navi-item active"
                : "navi-item "
            }
          >
            <Col
              xs={12}
              onClick={() => {
                if (!isNavigationAllowed) {
                  app.pushBackURL(DashboardPages.ARCHIVED_WORKSHOPS);
                  setShowModel(true);
                } else {
                  history.push(DashboardPages.ARCHIVED_WORKSHOPS);
                }
              }}
            >
              <div className="navi-icon">
                <MdArchive />
              </div>
              <div className="navi-text">Archive</div>
            </Col>
          </Row>
        )}
      </Container>
      <Modal show={fLoading} onHide={() => {}} centered>
        <Modal.Body>
          <p>Please wait forum is loading</p>
          <BarLoader
            height={4}
            width={"100%"}
            color={"#00629b"}
            loading={true}
          />
        </Modal.Body>
      </Modal>
      <ConfirmationModal
        loading={false}
        children={{
          headerText: "Sure you want to navigate away?",
          bodyText: (
            <>
              {app.getCurrentAction().isUploading ? (
                <>
                  <p>
                    Your file has not finished uploading and will not be saved.
                  </p>
                </>
              ) : (
                <>
                  <p>If you leave this page, your changes will not be saved.</p>
                </>
              )}
            </>
          ),
          cancelButtonText: app.getCurrentAction().isUploading
            ? "Finish Upload"
            : "Keep Editing",
          confirmButtonText: "Leave Page",
          confirmButtonColor: "red",
        }}
        show={showModel}
        onCancel={() => {
          app.popBackURL();
          setShowModel(false);
        }}
        onConfirm={() => {
          let currentAction: CurrentAction = {
            isUploading: false,
            isEditing: false,
            allowNavigationAway: true,
          };
          app.setCurrentAction(currentAction);

          history.push(app.popBackURL());
          setShowModel(false);
        }}
      />
    </>
  );
};

export default SideNavBar;
